import classnames from 'classnames'
import React, { ReactNode } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import * as Title from '@/components/common/header/title'
import { IRootState } from '@/modules'
import { appSelector } from '@/modules/common/app'

interface IHeaderProps {
  children?: ReactNode
  left?: JSX.Element
  right?: JSX.Element
  isDefault?: boolean
  isFixed?: boolean
  ignoreOS?: boolean
}

export const Header = (props: IHeaderProps) => {
  const { children, right, left, isDefault = false, isFixed = false, ignoreOS = false } = props

  const isAOS = useSelector<IRootState, boolean>(appSelector.isAOS, shallowEqual)
  const headerClassNames = classnames('header', {
    'is-default': isDefault,
    'is-fixed': isFixed, // 상단 고정
    'header--aos': !ignoreOS && isAOS,
  })

  return (
    <header className={headerClassNames}>
      {children || <Title.EmptyTitle />}
      {left}
      {right}
    </header>
  )
}
